import React from 'react';
import { Hero } from './components/Hero';
import { BelowFold } from './components/BelowFold';
import { useMetaPixel } from './components/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen text-slate-50 selection:bg-brand-500/30" data-id="element-0" data-mp="3k9ukzeabu4dn">
      <main data-id="element-1" data-mp="3farerqim1s43">
        <Hero data-id="element-2" data-mp="3f9yijjha2l07" />
        <BelowFold data-id="element-3" data-mp="3fbjar2g4druw" />
      </main>
    </div>;
}